import {Component, Input, OnInit} from '@angular/core';
import {BestPerformingExposure} from '../../../../../../models/influencer';
import {platformIconPathById} from '../../../../../app.constants';
import {DateUtils} from '../../../../../utils/date.utils';
import {Router} from '@angular/router';
import {PdfExportService} from '../../../../../services/export-pdf/pdf-export.service';
import {BestPerformingExposureComponent} from '../best-performing-exposure.component';
import {UserService} from '../../../../../services/user.service';

@Component({
  selector: 'best-performing-exposure-item',
  templateUrl: './best-performing-exposure-item.component.html',
  styleUrls: ['./best-performing-exposure-item.component.scss']
})
export class BestPerformingExposureItemComponent {

  @Input() bestPerformingExposure: BestPerformingExposure = new BestPerformingExposure();
  @Input() index: number;

  constructor(private pdfService: PdfExportService,
              private userService: UserService, private router: Router) { }

  getPlatformIcon(platformId: number): string {
    if (!platformId) {
      return '';
    }
    return platformIconPathById[platformId].path;
  }

  onLoadedImage() {
    this.pdfService.updateNumberImageLoaded(BestPerformingExposureComponent.COMPONENT_NAME);
  }

  onLoadedImageError() {
    console.log('Loaded image fail');
    this.pdfService.updateNumberImageLoaded(BestPerformingExposureComponent.COMPONENT_NAME);
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  formatPublishData(publishDate: string): string {
    return DateUtils.formatDate(publishDate);
  }

  openPostPage() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    // influencer platform version
    if (currentInfluencer) {
      return this.router.navigate(['dashboard', 'post', this.bestPerformingExposure.urlHash]);
    } else {
      return this.router.navigate(['post'], {queryParams: {
        influencerId: this.bestPerformingExposure.influencer_id,
        urlHash: this.bestPerformingExposure.urlHash,
        fullUrl: this.bestPerformingExposure.url,
        relativePath: this.bestPerformingExposure.relativepath,
        activeAccount: this.activeAccount
      }});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure-item/best-performing-exposure-item.component.ts